import { supabase } from './api'

export const revalidate = 0

// Helper function to get default logo
async function getDefaultLogo() {
	const { data, error } = await supabase.storage.from('companyinfo').getPublicUrl('defaultlogo.png')

	if (error) {
		throw new Error('Failed to fetch default logo')
	}
	return data.publicUrl
}

export async function getCompanyLogo(companyId) {
	try {
		// Return default logo if no companyId provided
		if (!companyId) {
			return await getDefaultLogo()
		}

		// Get company logo from database, ordered by creation time to get the latest
		const { data, error } = await supabase
			.from('companyinfo')
			.select('companylogo')
			.eq('companyid', companyId)
			.order('created_at', { ascending: false })
			.limit(1)
			.maybeSingle()

		// Handle database errors or missing logo
		if (error || !data?.companylogo) {
			return await getDefaultLogo()
		}

		// Get URL for company logo
		const { data: logoData, error: urlError } = await supabase.storage.from('companyinfo').getPublicUrl(data.companylogo)

		if (urlError) {
			throw new Error('Failed to generate logo URL')
		}

		return logoData.publicUrl
	} catch (err) {
		console.error('Error fetching company logo:', err)
		throw err
	}
}

export async function uploadCompanyLogo(filename, file) {
	try {
		const { data, error } = await supabase.storage.from('companyinfo').upload(filename, file, {
			upsert: true
		})
		if (error) {
			console.error('upload company logo error', error)
			if (error.statusCode === '403') {
				throw new Error('Permission denied: Unable to upload company logo. Please check storage permissions.')
			}
			throw new Error(`Failed to upload company logo: ${error.message}`)
		}
		return data
	} catch (err) {
		console.error('upload company logo error', err)
		throw err
	}
}

export async function updateCompanyLogo(companyId, logoFileName) {
	try {
		const { data, error } = await supabase
			.from('companyinfo')
			.update({
				companylogo: logoFileName
			})
			.eq('companyid',companyId)
			.select()

		if (error) {
			console.error('database update error', error)
			throw new Error(`Failed to update company logo: ${error.message}`)
		}
		return data
	} catch (err) {
		console.error('update company logo error', err)
		throw err
	}
}

export async function listCompanyLogos(companyId) {
	try {
		// First get all logo records from the database
		const { data: companyData, error: dbError } = await supabase.from('companyinfo').select('companylogo').eq('companyid', companyId)

		if (dbError) {
			throw new Error(`Failed to fetch company logos: ${dbError.message}`)
		}

		// Then list all files in the storage bucket
		const { data: storageData, error: storageError } = await supabase.storage.from('companyinfo').list()

		if (storageError) {
			throw new Error(`Failed to list storage files: ${storageError.message}`)
		}

		// Combine the information
		const results = {
			databaseRecords: companyData,
			storageFiles: storageData,
			analysis: {
				currentLogoInDB: companyData[companyData.length - 1]?.companylogo,
				totalStorageFiles: storageData.length,
				totalDatabaseRecords: companyData.length
			}
		}

		return results
	} catch (err) {
		console.error('Error listing company logos:', err)
		throw err
	}
}
